<template>
	<el-card style="margin: 20px">
		<div style="display: flex;justify-content: space-between;">

			<div style="flex: 1;margin-right: 50px;">

				<el-divider content-position="left">订单信息</el-divider>
				<el-descriptions :column="4" border v-if="orderData">
					<el-descriptions-item :label="item.label" v-for="(item,index) in columnList"
						:key="index">{{orderData[item.prop]}}</el-descriptions-item>
					<el-descriptions-item label="车辆"
						v-if="orderData.orderDetails.length">{{orderData.vehiclePlateNumber}}</el-descriptions-item>
					<el-descriptions-item label="地图">
						<el-button type="primary" plain size="mini" @click="openMap()">查看地图</el-button>
						<el-button type="primary" plain size="mini" @click="openMap('video')">实时播放视频</el-button>
						<el-button type="primary" plain size="mini" @click="openMap('history')">历史视频播放</el-button>
					</el-descriptions-item>
					<el-descriptions-item label="驾驶员">
						{{orderData.driverName}}
					</el-descriptions-item>
					<el-descriptions-item label="运输价">
						{{unitPrice}}
					</el-descriptions-item>
					<el-descriptions-item label="运输加价">
						{{addPrice}}
					</el-descriptions-item>
					<el-descriptions-item label="运输总额">
						{{totalPrice}}
					</el-descriptions-item>
					<el-descriptions-item label="结算总额" v-if="finalPrice>0">
						{{finalPrice}}
					</el-descriptions-item>


				</el-descriptions>
				<el-divider content-position="left">物品信息</el-divider>
				<el-table :data="orderData.orderDetails" border v-if="orderData" :span-method="mergeCarrierNo" row-key="id">
					<el-table-column type="expand">
						<template slot-scope="props">
							<el-form label-position="left" inline class="demo-table-expand">
								<el-form-item label="发货日期：">
									<span>{{ props.row.planShipDate }}</span>
								</el-form-item>
								<el-form-item label="计划到货日期：">
									<span>{{ props.row.planArrivalDate }}</span>
								</el-form-item>
								<el-form-item label="商业公司：">
									<span>{{ props.row.supplierName }}</span>
								</el-form-item>
								<el-form-item label="装货库：">
									<span>{{ props.row.originWarehouseName }}</span>
								</el-form-item>
								<el-form-item label="卸货库：">
									<span>{{ props.row.destinationWarehouseName }}</span>
								</el-form-item>
								<el-form-item label="结算公里数：">
									<span>{{ props.row.distance }}公里</span>
								</el-form-item>
								<el-form-item label="规格：">
									<span>{{ props.row.netWeight }}吨/{{ props.row.unit }}</span>
								</el-form-item>
								<el-form-item label="运输单价：">
									<span>{{ props.row.unitPrice }}元/吨/公里</span>
								</el-form-item>
								<el-form-item label="额外加价：">
									<span>{{ props.row.addPrice }}元/吨/公里</span>
								</el-form-item>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column align="center" label="序号" type="index" width="50" />
					<el-table-column align="center" label="物品" prop="productName">
					</el-table-column>
					<el-table-column align="center" label="承运单号" prop="carrierNo">
					</el-table-column>
					<el-table-column align="center" label="合同编号" prop="contractNo">
					</el-table-column>

					<el-table-column align="center" label="发货厂" prop="shipFromName">
					</el-table-column>
					<el-table-column align="center" label="到货厂" prop="supplierName">
					</el-table-column>
					<el-table-column align="center" label="数量">
						<template slot-scope="scope">
							{{ `${(scope.row.quantity || 0).toFixed(2)} ${scope.row.unit || ''}` }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="金额" width="120">
						<template slot-scope="scope">
							{{ (scope.row.totalPrice ).toFixed(2) }}
						</template>
					</el-table-column>



				</el-table>
				
				<!-- ============ 任务统计面板 ============ -->
				<div class="master-stat-panel" v-if="orderMasterData">
					<div class="master-stat-header">
						<div>
							<div class="master-stat-title">任务完成统计</div>
							<div class="master-stat-subtitle">按订单操作记录汇总任务时长、路线和节点明细</div>
						</div>
					</div>
					
					<!-- 统计摘要 -->
					<div class="master-stat-summary">
						<div class="summary-item">
							<div class="summary-label">任务完成时间</div>
							<div class="summary-value">{{ formatMasterTotalTime(orderMasterData) }}</div>
						</div>
						<div class="summary-item">
							<div class="summary-label">任务路线轨迹</div>
							<div class="summary-route">{{ getTaskRouteText() }}</div>
						</div>
						<div class="summary-item">
							<div class="summary-label">明细记录数(不含休息)</div>
							<div class="summary-value">{{ getMasterTotalCount() }}</div>
						</div>
					</div>

					<!-- ============ 步骤时间线（替代表格） ============ -->
					<div class="master-section-title">任务步骤时间线</div>
					<div class="timeline-wrapper">
						<div class="timeline-line"></div>
						<div 
							class="timeline-item" 
							v-for="(item, index) in getTimelineData()" 
							:key="index"
							:class="getTimelineItemClass(item)"
						>
							<div class="timeline-dot" :class="getDotClass(item.bigType)">
								<span class="dot-icon">{{ getDotIcon(item.bigType) }}</span>
							</div>
							<div class="timeline-content">
								<div class="timeline-header">
									<span class="timeline-type" :class="getTypeClass(item.bigType)">
										{{ getBigTypeText(item.bigType) }}
									</span>
									<span class="timeline-duration">{{ formatDetailDuration(item) }}</span>
								</div>
								<div class="timeline-location">{{ item.wareHouseName || '运输中' }}</div>
								<div class="timeline-time">
									{{ formatDateTime(item.minOperateTime) }} 
									<span class="time-arrow">→</span> 
									{{ formatDateTime(item.lastOperateTime) }}
								</div>
								<!-- 休息步骤显示休息时长 -->
								<div v-if="isRestType(item.bigType) && item.restTime" class="timeline-rest">
									休息时长：{{ formatRestTime(item.restTime) }}
								</div>
							</div>
						</div>
					</div>

					<!-- ============ 运输统计 ============ -->
					<div class="master-section-title transport-title">其中运输统计</div>
					<div class="transport-stat-grid">
<!-- 						<div class="transport-stat-item">
							<span class="transport-label">运输合计所用时间</span>
							<strong>{{ getTotalTransportTime() }}</strong>
						</div> -->
						<div class="transport-stat-item">
							<span class="transport-label">实际运行 / 所用时间</span>
							<strong>{{ orderMasterData?.totaltransportTime || '-' }}</strong>
						</div>
						<div class="transport-stat-item">
							<span class="transport-label">在途休息 / 所用时间</span>
							<strong>{{ getTotalRestTime() }}</strong>
						</div>
						<div class="transport-stat-item">
							<span class="transport-label">装货时间</span>
							<strong>{{ orderMasterData?.totalloadingTime || '-' }}</strong>
						</div>
						<div class="transport-stat-item">
							<span class="transport-label">卸货时间</span>
							<strong>{{ orderMasterData?.totalunloadingTime || '-' }}</strong>
						</div>
						<div class="transport-stat-item">
							<span class="transport-label">休息次数</span>
							<strong>{{ getRestCount() }}</strong>
						</div>
					</div>
				</div>
			</div>
			
			<!-- ============ 右侧步骤面板 ============ -->
			<div class="order-step-panel">
				<div class="order-step-title">订单步骤</div>
				<el-empty v-if="!stepGroups.length" description="暂无步骤" :image-size="90"></el-empty>
				<div class="step-list" v-else>
					<div class="step-item" v-for="group in stepGroups" :key="group.groupKey"
						:class="{ 'step-disabled': !isGroupAvailable(group), 'step-completed': isGroupCompleted(group) }">
						<div class="step-header">
							<div class="step-icon" :class="{ 'icon-completed': isGroupCompleted(group) }">
								{{ isGroupCompleted(group) ? '✓' : group.locationSequence }}
							</div>
							<div class="step-content">
								<div class="step-label">{{ group.locationName }}</div>
								<div class="step-status" :class="{ 'status-completed': isGroupCompleted(group) }">
									{{ group.completedCount }}/{{ group.steps.length }} 已完成
								</div>
							</div>
						</div>
						<div class="group-step-preview">
							<div class="group-step-chip" v-for="child in group.steps" :key="child.stepKey"
								:class="{ completed: child.status, current: child.flatIndex === currentStepIndex }">
								<span class="group-step-name">{{ getStepDisplayName(child) }}</span>
							</div>
						</div>
						<div class="group-step-detail" v-for="child in getVisibleGroupSteps(group)"
							:key="child.stepKey + '-detail'">
							<!-- 休息步骤：遍历所有进度记录 -->
							<template v-if="child.operationType===6">
								<div v-for="(progress, pIndex) in child.progressItems" :key="progress.progressId || pIndex" class="rest-detail-item">
									<div class="group-step-detail-title">完成休息({{ child.phase || '' }})</div>
									<div class="detail-time">
										休息时间：{{ progress.startTime || '-' }} <span v-if="progress.endTime">至
											{{ progress.endTime }}</span>
									</div>
<!-- 									<div class="detail-images" v-if="getStepImages(progress).length">
										<div v-for="item in getStepImages(progress)" :key="item" class="detail-image-wrap">
											<ImageViewer :src="item" />
										</div>
									</div> -->
									        <!-- 图片展示：缩略图 + 点击查看原图 -->
									<div class="detail-images" v-if="getStepImages(progress).length">
										<div v-for="item in getStepImages(progress)" :key="item" class="detail-image-wrap">
											<el-image
												:src="getSingleThumb(item)"
												:preview-src-list="[getFullImageUrl(item)]"
												fit="cover"
												class="detail-thumb"
												:preview-teleported="true"
											>
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>
										</div>
									</div>
									<div class="detail-location" v-if="progress.location">
										<div class="location-text">定位：{{ progress.location }}</div>
									</div>
									<div class="detail-location" v-if="progress.address">
										<div class="location-text">位置：{{ progress.address }}</div>
									</div>
								</div>
							</template>
							<!-- 其他步骤：保持原有逻辑 -->
							<template v-else>
								<div class="group-step-detail-title">{{ getStepDisplayName(child) }}</div>
								<div class="detail-time" v-if="child.operateTime">操作时间：{{ child.operateTime }}</div>
<!-- 								<div class="detail-images" v-if="getStepImages(child).length">
									<div v-for="item in getStepImages(child)" :key="item" class="detail-image-wrap">
										<ImageViewer :src="item" />
									</div>
								</div> -->
								<!-- 图片展示：缩略图 + 点击查看原图 -->
								<div class="detail-images" v-if="getStepImages(child).length">
									<div v-for="item in getStepImages(child)" :key="item" class="detail-image-wrap">
										<el-image
											:src="getSingleThumb(item)"
											:preview-src-list="[getFullImageUrl(item)]"
											fit="cover"
											class="detail-thumb"
											:preview-teleported="true"
										>
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</div>
								</div>								
								<div class="detail-location" v-if="child.location">
									<div class="location-text">定位：{{ child.location }}</div>
								</div>
								<div class="detail-location" v-if="child.address">
									<div class="location-text">位置：{{ child.address }}</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 地图弹窗 -->
		<el-dialog title="地图信息" :visible.sync="dialogVisible" width="80%" top="3vh" custom-class="order-map-dialog"
			@closed="handleMapClosed">
			<div class="map-wrapper">
				<div ref="mapContainer" class="map-container"></div>
				<div v-if="loading" class="loading-overlay">
					<el-icon class="is-loading"><i class="el-icon-loading"></i></el-icon>
					<span>地图加载中...</span>
				</div>
				<div v-else-if="error" class="error-message">
					<el-icon><i class="el-icon-warning"></i></el-icon>
					<span>{{ error }}</span>
					<el-button type="primary" size="small" @click="loadMapScript">重试</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 车辆信息面板 -->
		<div v-if="showCarInfo" class="car-info-panel">
			<div class="car-info-header">
				<h3>车辆信息</h3>
				<el-button type="text" @click="showCarInfo = false" icon="el-icon-close" class="close-button">

				</el-button>
			</div>
			<div class="car-info-content">
				<div class="info-item">
					<span class="info-label">车牌号：</span>
					<span class="info-value">{{ carInfo.carPlate }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">公司名称：</span>
					<span class="info-value">{{ carInfo.teamName }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">车牌颜色：</span>
					<span class="info-value">{{ carInfo.plateColor }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">速度：</span>
					<span class="info-value">{{ carInfo.speed }} km/h</span>
				</div>
				<div class="info-item">
					<span class="info-label">方向：</span>
					<span class="info-value">{{ carInfo.drctCn }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">司机：</span>
					<span class="info-value">{{ carInfo.drvName || '未知' }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">司机电话：</span>
					<span class="info-value">{{ carInfo.drvPhone || '未知' }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">当日里程：</span>
					<span class="info-value">{{ carInfo.mile }} km</span>
				</div>
				<div class="info-item">
					<span class="info-label">累计里程：</span>
					<span class="info-value">{{ carInfo.prevDayTotalMile }} km</span>
				</div>
				<div class="info-item">
					<span class="info-label">ACC状态：</span>
					<span class="info-value">{{ carInfo.accTime }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">运行时间：</span>
					<span class="info-value">{{ carInfo.runStopTime }}</span>
				</div>

				<div class="info-item">
					<span class="info-label">更新时间：</span>
					<span class="info-value">{{ carInfo.time }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">状态：</span>
					<span class="info-value">{{ carInfo.stateCn }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">GPS信号：</span>
					<span class="info-value">{{ carInfo.satl }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">车辆状态：</span>
					<span class="info-value">{{ carInfo.expState === '1' ? '正常' : '异常' }}</span>
				</div>
				<div class="info-item">
					<span class="info-label">油量：</span>
					<span class="info-value">{{ carInfo.oil }}</span>
				</div>
				<div class="info-item" style="width: 100%;">
					<span class="info-label">当前位置：</span>
					<span class="info-value">{{ carInfo.addr || '未知' }}</span>
				</div>
				<div class="info-item" style="width: 100%;">
					<el-button type="primary" @click="showVideoDialog=true">实时播放视频</el-button>
					<el-button type="primary" @click="showVideoDialogHistory=true">历史视频播放</el-button>
				</div>
			</div>
		</div>

		<!-- 视频播放弹窗 -->
		<el-dialog title="实时视频播放" append-to-body :visible.sync="showVideoDialog" width="1300px"
			:close-on-click-modal="false">
			<div class="VideoRealPlay">
				<iframe :src="videoUrl" v-if="showVideoDialog" width="100%" height="100%" frameborder="0"></iframe>
			</div>
		</el-dialog>
		<el-dialog title="历史视频播放" append-to-body fullscreen class="homehistoryVido"
			:visible.sync="showVideoDialogHistory" width="100%" height="100%" :close-on-click-modal="false">
			<div class="historyVideoRealPlay">
				<iframe :src="historyVideoUrl" v-if="showVideoDialogHistory" width="100%" height="100%"
					frameborder="0"></iframe>
			</div>
		</el-dialog>
	</el-card>
</template>

<style>
	/* ============ 时间线样式 ============ */
	.timeline-wrapper {
		position: relative;
		padding: 16px 20px 16px 40px;
		background: #fafcfe;
	}

	.timeline-line {
		position: absolute;
		left: 18px;
		top: 30px;
		bottom: 30px;
		width: 3px;
		background: linear-gradient(to bottom, #409eff, #67c23a);
		border-radius: 2px;
	}

	.timeline-item {
		position: relative;
		padding: 12px 0 12px 28px;
		border-left: none;
		transition: all 0.2s;
	}

	.timeline-item:hover {
		background: #f0f7ff;
		border-radius: 8px;
		margin: 0 -12px;
		padding-left: 40px;
	}

	.timeline-dot {
		position: absolute;
		left: -6px;
		top: 16px;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 14px;
		font-weight: 700;
		z-index: 2;
		border: 3px solid #fff;
		box-shadow: 0 2px 8px rgba(0,0,0,0.15);
	}

	.dot-loading {
		background: #409eff;
	}

	.dot-transport {
		background: #e6a23c;
	}

	.dot-unloading {
		background: #67c23a;
	}

	.dot-rest {
		background: #909399;
	}

	.dot-icon {
		font-size: 12px;
	}

	.timeline-content {
		background: #fff;
		border-radius: 8px;
		padding: 12px 16px;
		border: 1px solid #e8ecf1;
		transition: all 0.2s;
	}

	.timeline-item:hover .timeline-content {
		border-color: #409eff;
		box-shadow: 0 2px 12px rgba(64, 158, 255, 0.12);
	}

	.timeline-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 6px;
	}

	.timeline-type {
		font-size: 14px;
		font-weight: 700;
		padding: 2px 12px;
		border-radius: 4px;
	}

	.type-loading {
		color: #409eff;
		background: #ecf5ff;
	}

	.type-transport {
		color: #e6a23c;
		background: #fdf6ec;
	}

	.type-unloading {
		color: #67c23a;
		background: #f0f9eb;
	}

	.type-rest {
		color: #909399;
		background: #f4f4f5;
	}

	.timeline-duration {
		font-size: 14px;
		font-weight: 600;
		color: #b40000;
	}

	.timeline-location {
		font-size: 14px;
		color: #303133;
		font-weight: 500;
		margin-bottom: 4px;
		word-break: break-all;
	}

	.timeline-time {
		font-size: 12px;
		color: #909399;
	}

	.time-arrow {
		margin: 0 6px;
		color: #c0c4cc;
	}

	.timeline-rest {
		margin-top: 4px;
		font-size: 12px;
		color: #909399;
	}

	/* 时间线项完成状态 */
	.timeline-item.completed .timeline-content {
		border-color: #c2e7b0;
		background: #fafffe;
	}

	.timeline-item.in-progress .timeline-content {
		border-color: #b3d8ff;
		background: #f5faff;
	}

	.timeline-item.in-progress .timeline-dot {
		animation: pulse-dot 1.5s ease-in-out infinite;
	}

	@keyframes pulse-dot {
		0%, 100% { box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.4); }
		50% { box-shadow: 0 0 0 8px rgba(64, 158, 255, 0); }
	}

	/* ============ 原样式保留 ============ */
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 30%;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.master-stat-panel {
		margin-top: 18px;
		border: 1px solid #d7e6f2;
		border-radius: 8px;
		background: #f8fbfd;
		overflow: hidden;
	}

	.master-stat-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;
		padding: 16px 18px;
		background: linear-gradient(90deg, #eef7ff 0%, #f8fbfd 100%);
		border-bottom: 1px solid #d7e6f2;
	}

	.master-stat-title {
		font-size: 17px;
		font-weight: 700;
		color: #b40000;
	}

	.master-stat-subtitle {
		margin-top: 5px;
		font-size: 12px;
		color: #7a8a99;
	}

	.master-stat-summary {
		display: grid;
		grid-template-columns: minmax(160px, 0.8fr) minmax(240px, 1.5fr) minmax(120px, 0.6fr);
		border-bottom: 1px solid #d7e6f2;
	}

	.summary-item {
		padding: 14px 16px;
		border-right: 1px solid #d7e6f2;
		min-width: 0;
	}

	.summary-item:last-child {
		border-right: none;
	}

	.summary-label {
		font-size: 13px;
		font-weight: 700;
		color: #b40000;
		margin-bottom: 8px;
	}

	.summary-value {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}

	.summary-route {
		font-size: 14px;
		color: #ff3b30;
		line-height: 1.5;
		word-break: break-all;
	}

	.master-section-title {
		padding: 12px 16px;
		font-size: 15px;
		font-weight: 700;
		color: #b40000;
		border-bottom: 1px solid #d7e6f2;
		background: #fff;
	}

	.transport-title {
		border-top: 1px solid #d7e6f2;
	}

	.transport-stat-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	.transport-stat-item {
		padding: 14px 16px;
		border-right: 1px solid #d7e6f2;
		background: #f4f8fb;
		min-width: 0;
	}

	.transport-stat-item:last-child {
		border-right: none;
	}

	.transport-label {
		display: block;
		margin-bottom: 8px;
		font-size: 13px;
		color: #606266;
	}

	.transport-stat-item strong {
		font-size: 15px;
		color: #303133;
		word-break: break-all;
	}

	/* 右侧面板样式 */
	.order-step-panel {
		flex-shrink: 0;
		width: 500px;
		max-height: calc(100vh - 80px);
		overflow: auto;
		padding-left: 4px;
	}

	.order-step-title {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 12px;
	}

	.step-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.step-item {
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 8px;
		background: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	}

	.step-disabled {
		opacity: 0.68;
		background: #fafafa;
	}

	.step-completed {
		border-color: #c2e7b0;
		background: #f0f9eb;
	}

	.step-header {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.step-icon {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #ecf5ff;
		color: #409eff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		flex-shrink: 0;
	}

	.step-icon.icon-completed {
		background: #67c23a;
		color: #fff;
	}

	.step-content {
		min-width: 0;
		flex: 1;
	}

	.step-label {
		font-size: 15px;
		color: #333;
		display: block;
		margin-bottom: 5px;
	}

	.step-status {
		font-size: 12px;
		color: #999;
	}

	.step-status.status-completed {
		color: #67C23A;
	}

	.group-step-preview {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 12px;
	}

	.group-step-chip {
		max-width: 100%;
		padding: 5px 9px;
		border-radius: 4px;
		background: #f4f4f5;
		color: #606266;
		font-size: 12px;
		line-height: 1.35;
		border: 1px solid #e4e7ed;
	}

	.group-step-chip.completed {
		background: #e1f3d8;
		color: #67c23a;
		border-color: #c2e7b0;
	}

	.group-step-chip.current {
		background: #ecf5ff;
		color: #409eff;
		border-color: #b3d8ff;
	}

	.group-step-name {
		word-break: break-all;
	}

	.group-step-detail {
		margin-top: 12px;
		padding-top: 12px;
		border-top: 1px dashed #dcdfe6;
	}

	.group-step-detail-title {
		font-size: 13px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 8px;
	}

	.detail-time {
		font-size: 12px;
		color: #666;
		display: block;
		margin-bottom: 7px;
	}

	.detail-images {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 7px;
	}

	.detail-image-wrap {
		margin-right: 10px;
		margin-bottom: 8px;
	}

	.detail-location {
		font-size: 12px;
		color: #666;
	}

	.location-text {
		display: block;
	}

	/* 地图样式 */
	.map-wrapper {
		position: relative;
		width: 100%;
	}

	.map-container {
		/* 天地图内部图层是 position:absolute，容器必须定位，
		   否则图层会以 .el-dialog 为基准铺满整个弹窗 */
		position: relative;
		width: 100%;
		height: 68vh;
		min-height: 420px;
		overflow: hidden;
	}

	.loading-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(255, 255, 255, 0.8);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.loading-overlay .is-loading {
		font-size: 32px;
		color: #409eff;
		margin-bottom: 16px;
		animation: rotate 1s linear infinite;
	}

	@keyframes rotate {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.error-message {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(255, 255, 255, 0.9);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		padding: 20px;
		text-align: center;
	}

	.car-info-panel {
		position: absolute;
		bottom: 20px;
		right: 20px;
		width: 600px;
		background-color: white;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
		z-index: 10001;
		overflow: hidden;
	}

	.car-info-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
		background-color: #f5f7fa;
		border-bottom: 1px solid #ebeef5;
	}

	.car-info-header h3 {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}

	.close-button {
		padding: 0;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.car-info-content {
		padding: 16px;
		max-height: 600px;
		overflow: auto;
		display: flex;
		flex-wrap: wrap;
	}

	.info-item {
		margin-bottom: 10px;
		display: flex;
		align-items: center;
		width: 50%;
	}

	.info-label {
		font-size: 14px;
		color: #606266;
	}

	.info-value {
		flex: 1;
		font-size: 14px;
		color: #303133;
		font-weight: 500;
	}

	.VideoRealPlay {
		height: 610px;
		width: 100%;
	}

	.historyVideoRealPlay {
		height: 100%;
		width: 100%;
	}

	.homehistoryVido .el-dialog {
		display: flex;
		flex-direction: column;
	}

	.homehistoryVido .el-dialog__body {
		flex: 1;
	}
</style>

<script>
	import api from '../utils/api'
	import { loadTianditu, TIANDITU_TK } from '../utils/tianditu'
	export default {
		name: 'OrderDea',
		data() {
			return {
				orderMasterData: null,
				currentStepIndex: 0,
				showVideoDialog: false,
				showVideoDialogHistory: false,

				unitPrice: '',
				addPrice: '',
				totalPrice: '',
				finalPrice: '',
				loading: true,
				error: null,
				showCarInfo: false,
				carInfo: {
					name: '',
					speed: '',
					driver: '',
					plate: ''
				},
				dialogVisible: false,
				orderData: null,
				progressList: [],
				stepTypes: [],
				stepGroups: [],
				flatStepTypes: [],


				columnList: [{
						prop: "orderNo",
						label: "订单号",
						width: 100,

					},
					{
						prop: "orderType",
						label: "订单类型",
						width: 100,

					},


					{
						prop: "statusName",
						label: "状态",
						width: 100,

					},

					{
						prop: "createTime",
						label: "创建时间",
						width: 100,
					},
					{
						prop: "remark",
						label: "备注",
						width: 200,
					},
					{
						prop: "createBy",
						label: "创建人",
						width: 100,
					},
				],
				vehicleData: null,
				carProgress: null,
				routeData:null
			}
		},

		computed: {
			videoUrl() {
				if (!this.showVideoDialog || !this.carInfo.carPlate) {
					return '/play/aa.html'
				}
				const carPlate = encodeURIComponent(this.carInfo.carPlate || '')
				const carId = encodeURIComponent(this.carInfo.tmnKey || '')
				const videoServerIp = process.env.VUE_APP_VIDEO_SERVER_IP
				const videoServerPort = process.env.VUE_APP_VIDEO_SERVER_PORT
				return `/play/aa.html?carPlate=${carPlate}&carId=${carId}&ip=${videoServerIp}&port=${videoServerPort}`
			},
			historyVideoUrl() {
				if (!this.showVideoDialogHistory || !this.carInfo.carPlate) {
					return '/play/bb.html'
				}
				const carPlate = encodeURIComponent(this.carInfo.carPlate || '')
				const carId = encodeURIComponent(this.carInfo.tmnKey || '')
				const videoServerIp = process.env.VUE_APP_VIDEO_SERVER_IP
				const videoServerPort = process.env.VUE_APP_VIDEO_SERVER_PORT
				return `/play/bb.html?carPlate=${carPlate}&carId=${carId}&ip=${videoServerIp}&port=${videoServerPort}`
			}
		},
		created() {
			// 地图实例和图层对象不放进 data，避免 Vue 对天地图的内部结构做响应式劫持
			this.map = null
			this.markers = []
			this.labels = []
			this.routeLine = null
			this.fallbackLine = null
			// 本轮路线是否已出结果（真实路线或兜底直线），防止重复绘制
			this.routeSettled = false
		},
		mounted() {
			this.getDea()
			api.get('/api/Order/OrderMaxJl', {
				orderId: this.$route.query.id
			}).then((res)=>{
				this.routeData= res.data
			})
			
			api.get('/api/OrderOperation/ordertimeuse/'+this.$route.query.id, {}).then((res)=>{
				this.orderMasterData=res.data
			})
		},
		methods: {
			/**
			 * 合并承运单号相同的行
			 */
			mergeCarrierNo({ row, column, rowIndex, columnIndex }) {
				// 需要合并的列索引（从0开始）
				// 序号:0, 物品:1, 承运单号:2, 合同编号:3, 发货厂:4, 到货厂:5
				const mergeColumns = [3,5,6] // 承运单号、合同编号、发货厂、到货厂
				
				// 如果不是需要合并的列，不处理
				if (!mergeColumns.includes(columnIndex)) {
					return [1, 1]
				}

				const data = this.orderData.orderDetails
				const currentCarrierNo = data[rowIndex].carrierNo

				// 如果当前行是承运单号的第一行，计算合并行数
				if (rowIndex === 0 || data[rowIndex - 1].carrierNo !== currentCarrierNo) {
					let rowspan = 1
					for (let i = rowIndex + 1; i < data.length; i++) {
						if (data[i].carrierNo === currentCarrierNo) {
							rowspan++
						} else {
							break
						}
					}
					return [rowspan, 1]
				}
				
				// 不是第一行，隐藏（返回 [0, 0]）
				return [0, 0]
			},
			// ============ 时间线数据 ============
			getTimelineData() {
				if (!this.orderMasterData || !Array.isArray(this.orderMasterData.details)) {
					return []
				}
				// 按时间排序
				const sorted = [...this.orderMasterData.details].sort((a, b) => {
					return new Date(a.minOperateTime) - new Date(b.minOperateTime)
				})
				return sorted
			},

			getTimelineItemClass(item) {
				const bigType = String(item.bigType || '').toLowerCase()
				if (bigType === 'rest') return 'completed'
				// 检查是否已完成（有结束时间且不等于开始时间）
				if (item.minOperateTime && item.lastOperateTime && 
					new Date(item.lastOperateTime) > new Date(item.minOperateTime)) {
					return 'completed'
				}
				return 'in-progress'
			},

			getDotClass(bigType) {
				const type = String(bigType || '').toLowerCase()
				const map = {
					'loading': 'dot-loading',
					'load': 'dot-loading',
					'transporting': 'dot-transport',
					'transport': 'dot-transport',
					'unloading': 'dot-unloading',
					'unload': 'dot-unloading',
					'rest': 'dot-rest',
					'transportrest': 'dot-rest'
				}
				return map[type] || 'dot-loading'
			},

			getDotIcon(bigType) {
				const type = String(bigType || '').toLowerCase()
				const map = {
					'loading': '📦',
					'load': '📦',
					'transporting': '🚛',
					'transport': '🚛',
					'unloading': '🏭',
					'unload': '🏭',
					'rest': '☕',
					'transportrest': '☕'
				}
				return map[type] || '📍'
			},

			getTypeClass(bigType) {
				const type = String(bigType || '').toLowerCase()
				const map = {
					'loading': 'type-loading',
					'load': 'type-loading',
					'transporting': 'type-transport',
					'transport': 'type-transport',
					'unloading': 'type-unloading',
					'unload': 'type-unloading',
					'rest': 'type-rest',
					'transportrest': 'type-rest'
				}
				return map[type] || 'type-loading'
			},

			isRestType(bigType) {
				const type = String(bigType || '').toLowerCase()
				return type === 'rest' || type === 'transportrest'
			},

			formatRestTime(minutes) {
				if (!minutes) return '0分钟'
				const mins = Math.round(minutes)
				const hours = Math.floor(mins / 60)
				const remainMins = mins % 60
				if (hours > 0 && remainMins > 0) {
					return `${hours}小时${remainMins}分钟`
				} else if (hours > 0) {
					return `${hours}小时`
				} else {
					return `${remainMins}分钟`
				}
			},

			// ============ 原有方法 ============
			async openMap(type) {
				if(!this.routeData){
					return
				}
				
				await api.get('/api/Vehicles/' + this.orderData.vehicleId).then((res) => {
					this.vehicleData = res.data
				})
				if (this.vehicleData) {
					api.get('/api/ZhiXing/GetCarGpsNow', {
						carPlate: this.vehicleData.plateNumber
					}).then((res) => {
						if (res.data.list && res.data.list.length) {
							this.carProgress = res.data.list[0]
							if (!type) {
								this.dialogVisible = true
								// 等弹窗渲染出来再建图，否则容器还没有尺寸
								this.$nextTick(() => this.loadMapScript())
								return
							}
							this.carInfo = res.data.list[0]
							if (type === 'video') {
								this.showVideoDialog = true
							} else {
								this.showVideoDialogHistory = true
							}
						}

					})
				}

				return

			},
			async getDea() {
				if (!this.$route.query.id) {
					return
				}
				//
				await api.get('/api/Order/' + this.$route.query.id).then((res) => {
					this.orderData = res.data


					let unitPrice = 0
					let addPrice = 0
					let totalPrice = 0
					let finalPrice = 0
					if (res.data.orderDetails && res.data.orderDetails.length) {
						res.data.orderDetails.forEach((row) => {
							unitPrice += (row.quantity * row.netWeight * row.unitPrice * row.distance)
							addPrice += (row.quantity * row.netWeight * row.addPrice * row.distance)
							totalPrice += (row.quantity * row.netWeight * (row.addPrice + row
								.unitPrice) * row.distance)
							if (row.finalPrice !== undefined) {
								finalPrice += (row.quantity * row.netWeight * row.finalPrice * row
									.distance)
							}
						})
					}
					this.unitPrice = unitPrice.toFixed(2)
					this.addPrice = addPrice.toFixed(2)
					this.totalPrice = totalPrice.toFixed(2)
					this.finalPrice = finalPrice.toFixed(2)
					//this.loadMapScript()
				})

				await api.get('/api/OrderOperation/order/' + this.orderData.id).then((res) => {
					this.progressList = res.data || []
				})
				this.loadOrderSteps()

			},
			async loadOrderSteps() {
				try {
					const res = await api.get('/api/OrderStepTemplate/by-order-id', {
						orderId: this.orderData.id
					})
					this.setOrderStepGroups(res.data)
				} catch (e) {
					await api.get('/api/OrderStepTemplate/by-order-type', {
						orderType: this.orderData.orderType
					}).then((res) => {
						this.setOrderStepGroups(res.data)
					})
				}
			},
			setOrderStepGroups(data) {
				const groups = this.normalizeOrderStepGroups(data)
				this.stepGroups = groups
				this.flatStepTypes = groups.reduce((list, group) => {
					return list.concat(group.steps)
				}, [])
				this.stepTypes = this.flatStepTypes
				this.currentStepIndex = this.getLastCompletedStepIndex() + 1
			},
			getLastCompletedStepIndex() {
				for (let index = this.flatStepTypes.length - 1; index >= 0; index--) {
					if (this.flatStepTypes[index].status) {
						return index
					}
				}
				return -1
			},
			normalizeOrderStepGroups(data) {
				const list = Array.isArray(data) ? data : []
				if (list.some((item) => this.hasChildSteps(item))) {
					return this.buildGroupedSteps(list)
				}
				return this.buildGroupedSteps([{
					locationName: '订单流程',
					locationSequence: 1,
					locationType: '',
					steps: list
				}])
			},
			hasChildSteps(item) {
				return Array.isArray(item.steps) || Array.isArray(item.children) || Array.isArray(item.list)
			},
			buildGroupedSteps(locations) {
				let flatIndex = 0
				return locations.map((location, locationIndex) => {
					const locationSequence = location.locationSequence || location.sequence || locationIndex + 1
					const steps = this.getLocationSteps(location)
					const locationSteps = steps.map((step, stepIndex) => {
						const orderDetailId = locationSequence
						const progressItems = this.getProgressItems(orderDetailId, step)
						const progressItem = progressItems.length ? progressItems[progressItems.length -
							1] : null
						return {
							...step,
							...(progressItem || {}),
							locationName: location.locationName || `步骤${locationSequence}`,
							locationType: location.locationType || '',
							locationSequence,
							orderDetailId,
							stepKey: `${locationSequence}-${step.stepCode || step.id || stepIndex}`,
							flatIndex: flatIndex++,
							progressItems
						}
					})
					const completedCount = locationSteps.filter((step) => step.status).length
					return {
						...location,
						locationName: location.locationName || `步骤${locationSequence}`,
						locationSequence,
						groupKey: `${locationSequence}-${location.locationName || locationIndex}`,
						steps: locationSteps,
						completedCount
					}
				})
			},
			getLocationSteps(location) {
				if (Array.isArray(location.steps)) {
					return location.steps
				}
				if (Array.isArray(location.children)) {
					return location.children
				}
				if (Array.isArray(location.list)) {
					return location.list
				}
				return []
			},
			getProgressItems(orderDetailId, step) {
				return this.progressList.filter((progress) => {
					return this.isSameProgressStep(progress, orderDetailId, step)
				}).map((progress) => {
					const progressItem = {
						...progress,
						progressId: progress.id,
						stepId: orderDetailId
					}
					delete progressItem.id
					return progressItem
				}).sort((a, b) => {
					const aTime = new Date(a.startTime || a.operateTime || 0).getTime()
					const bTime = new Date(b.startTime || b.operateTime || 0).getTime()
					return aTime - bTime
				})
			},
			isSameProgressStep(progress, orderDetailId, step) {
				const progressIds = [
					progress.orderDetailId,
					progress.stepId,
					progress.orderStepTemplateId,
					progress.templateId
				].filter((value) => value !== undefined && value !== null && value !== '')
				const stepIds = [
					step.id,
					step.stepId,
					step.orderDetailId,
					step.orderStepTemplateId,
					step.templateId
				].filter((value) => value !== undefined && value !== null && value !== '')
				const matchOldStepId = progressIds.some((progressId) => {
					return stepIds.some((stepId) => String(progressId) === String(stepId))
				})
				if (matchOldStepId) {
					return this.isSameStepCode(progress, step)
				}
				const matchLocation = progress.orderDetailId !== undefined &&
					String(progress.orderDetailId) === String(orderDetailId)
				return matchLocation && this.hasBothStepCode(progress, step) && this.isSameStepCode(progress, step)
			},
			hasBothStepCode(progress, step) {
				return progress.stepCode !== undefined && progress.stepCode !== null && progress.stepCode !== '' &&
					step.stepCode !== undefined && step.stepCode !== null && step.stepCode !== ''
			},
			isSameStepCode(progress, step) {
				if (!this.hasBothStepCode(progress, step)) {
					return true
				}
				return String(progress.stepCode) === String(step.stepCode)
			},
			isGroupCompleted(group) {
				return !!group && Array.isArray(group.steps) && group.steps.length > 0 && group.completedCount === group
					.steps.length
			},
			isGroupAvailable(group) {
				if (!group || !group.steps || !group.steps.length) {
					return false
				}
				const firstTodoIndex = this.flatStepTypes.findIndex((item) => !item.status)
				return this.isGroupCompleted(group) || group.steps.some((step) => step.flatIndex <= firstTodoIndex)
			},
			getVisibleGroupSteps(group) {
				if (!group || !Array.isArray(group.steps)) {
					return []
				}
				return group.steps.filter((step) => {
					return step.status || (step.operationType === 6 && step.status === 0)
				})
			},
			getStepDisplayName(step) {
				if (step.operationType === 6) {
					if (step.status === 0) {
						return `休息中(${step.phase || ''})`
					}
					if (step.status === 1) {
						return `完成休息(${step.phase || ''})`
					}
				}
				return step.phase ? `${step.stepName}(${step.phase})` : step.stepName
			},
			// 获取原图完整路径（用于预览）
			getFullImageUrl(imageUrl) {
				if (!imageUrl) return ''
				if (imageUrl.startsWith('http')) {
					return imageUrl
				}
				return `https://www.sqwlgz.xin:8008/${imageUrl}`
			},
			getStepImages(step) {
				if (!step || !step.imageUrls) {
					return []
				}
				if (Array.isArray(step.imageUrls)) {
					return step.imageUrls
				}
				return String(step.imageUrls).split(',').filter(Boolean)
			},
			// 获取缩略图路径
			getThumbImage(step) {
				const images = this.getStepImages(step)
				if (!images.length) return []
				return images.map(url => {
					// 提取文件名
					const fileName = url.split('/').pop()
					// 提取公共名称（去掉扩展名）
					const nameWithoutExt = fileName.replace(/\.[^.]+$/, '')
					// 返回缩略图路径
					return `thumbpic/thumb_${nameWithoutExt}.jpg`
				})
			},

			// 获取原图路径
			getOriginalImage(step) {
				return this.getStepImages(step)
			},

			// 获取单张图片的缩略图
			getSingleThumb(imageUrl) {
				if (!imageUrl) return ''
				const fileName = imageUrl.split('/').pop()
				const nameWithoutExt = fileName.replace(/\.[^.]+$/, '')
				return `https://www.sqwlgz.xin:8008/thumbpic/thumb_${nameWithoutExt}.jpg`
			},

			// 获取单张图片的原图
			getSingleOriginal(imageUrl) {
				return imageUrl
			},

			// 判断是否为图片（根据扩展名）
			isImage(url) {
				if (!url) return false
				const ext = url.split('.').pop().toLowerCase()
				return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)
			},	
			getMasterDetails() {
				if (!this.orderMasterData || !Array.isArray(this.orderMasterData.details)) {
					return []
				}
				return this.orderMasterData.details
			},
			formatMasterTotalTime(data) {
				if (!data) {
					return '-'
				}
				const hours = Number(data.totalHours || 0)
				const minutes = Number(data.totalMinutes || 0)
				if (!hours && !minutes) {
					return '0分钟'
				}
				return `${hours}小时${minutes}分钟`
			},
			getMasterTotalCount() {
				const keyList = ['loading', 'transport', 'unloading']
				return this.getMasterRows()
					.filter(row => keyList.some(key => String(row.key || '').startsWith(key)))
					.reduce((sum, row) => {
						return sum + Number(row.count || 0)
					}, 0)
			},
			getTaskRouteText() {
				if (this.orderMasterData && this.orderMasterData.routeIng) {
					return this.orderMasterData.routeIng
				}
				const excludeNames = ['运输中', '检查车', '结束', '', '无'];
				const names = this.getMasterDetails()
					.filter(item => {
						const bigType = String(item.bigType || '').toLowerCase()
						return bigType === 'loading' || bigType === 'load' || bigType === 'unloading' || bigType === 'unload'
					})
					.map((item) => item.wareHouseName)
					.filter(name => name && !excludeNames.includes(name))
					.filter((value, index, self) => self.indexOf(value) === index); 
				if (names.length) {
					return names.join(' → ')
				}
				if (this.routeData && this.routeData.routeName) {
					return this.routeData.routeName
				}
				if (this.routeData && this.routeData.name) {
					return this.routeData.name
				}
				return '-'
			},
			getMasterRows() {
				const filterTypes = ['Loading', 'Load', 'Transporting', 'Transport', 'Unloading', 'Unload', 'Rest']
				return this.getMasterDetails()
					.filter(item => filterTypes.includes(String(item.bigType || '')))
					.map((item, index) => {
						return {
							...item,
							key: `${String(item.bigType || '').toLowerCase()}-${index}`,
							label: this.getBigTypeText(item.bigType)
						}
					})
			},
			buildMasterRow(key, label, types) {
				const detail = this.getDetailByTypes(types)
				return {
					key,
					label,
					bigType: detail && detail.bigType,
					wareHouseName: detail && detail.wareHouseName,
					count: detail ? detail.count : 0,
					lastOperateTime: detail && detail.lastOperateTime,
					minOperateTime: detail && detail.minOperateTime
				}
			},
			getDetailByTypes(types) {
				const typeList = types.map((type) => String(type).toLowerCase())
				return this.getMasterDetails().find((item) => {
					return typeList.indexOf(String(item.bigType || '').toLowerCase()) > -1
				}) || null
			},
			getTotalTransportTime() {
				const types = ['Transporting', 'Transport', 'Rest', 'TransportRest']
				const details = this.getMasterDetails().filter(item => {
					const bigType = String(item.bigType || '').toLowerCase()
					return types.some(type => bigType === String(type).toLowerCase())
				})
				
				let totalMinutes = 0
				details.forEach(item => {
					if (!item.minOperateTime || !item.lastOperateTime) {
						return
					}
					const start = new Date(item.minOperateTime).getTime()
					const end = new Date(item.lastOperateTime).getTime()
					if (Number.isNaN(start) || Number.isNaN(end)) {
						return
					}
					totalMinutes += Math.max(0, Math.round((end - start) / 60000))
				})
				
				const hours = Math.floor(totalMinutes / 60)
				const minutes = totalMinutes % 60
				if (!hours && !minutes) {
					return '0分钟'
				}
				return `${hours ? `${hours}小时` : ''}${minutes ? `${minutes}分钟` : ''}`
			},
			getBigTypeText(type) {
				const typeText = {
					Loading: '装货',
					Load: '装货',
					Transporting: '运输',
					Transport: '运输',
					Unloading: '卸货',
					Unload: '卸货',
					Rest: '休息',
					TransportRest: '在途休息',
					Running: '实际运行',
					ActualRunning: '实际运行'
				}
				return typeText[type] || type
			},
			formatDateTime(value) {
				if (!value) {
					return '-'
				}
				const date = new Date(value)
				if (Number.isNaN(date.getTime())) {
					return value
				}
				const pad = (num) => {
					return num < 10 ? `0${num}` : String(num)
				}
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
			},
			formatDetailDuration(row) {
				if (!row || !row.minOperateTime || !row.lastOperateTime) {
					return '-'
				}
				const start = new Date(row.minOperateTime).getTime()
				const end = new Date(row.lastOperateTime).getTime()
				if (Number.isNaN(start) || Number.isNaN(end) ||(start==end)) {
					return '-'
				}
				const totalMinutes = Math.max(0, Math.round((end - start) / 60000))
				const hours = Math.floor(totalMinutes / 60)
				const minutes = totalMinutes % 60
				if (!hours && !minutes) {
					return '0分钟'
				}
				return `${hours ? `${hours}小时` : ''}${minutes ? `${minutes}分钟` : ''}`
			},
			getRestCount() {
				const restDetails = this.getMasterDetails().filter(item => {
					const bigType = String(item.bigType || '').toLowerCase()
					return bigType === 'rest' || bigType === 'transportrest'
				})
				return restDetails.reduce((sum, item) => {
					return sum + Number(item.count || 0)
				}, 0)
			},
			getTotalRestTime() {
				const restDetails = this.getMasterDetails().filter(item => {
					const bigType = String(item.bigType || '').toLowerCase()
					return bigType === 'rest' || bigType === 'transportrest'
				})
				const totalMinutes = restDetails.reduce((sum, item) => {
					if (!item.minOperateTime || !item.lastOperateTime) {
						return sum
					}
					const start = new Date(item.minOperateTime).getTime()
					const end = new Date(item.lastOperateTime).getTime()
					if (Number.isNaN(start) || Number.isNaN(end)) {
						return sum
					}
					return sum + Math.max(0, Math.round(Math.abs(end - start) / 60000))
				}, 0)
				const hours = Math.floor(totalMinutes / 60)
				const minutes = totalMinutes % 60
				if (!hours && !minutes) {
					return '0分钟'
				}
				return `${hours ? `${hours}小时` : ''}${minutes ? `${minutes}分钟` : ''}`
			},
			/* ==================== 地图（天地图 v4.0） ==================== */
			loadMapScript() {
				if (!this.carProgress) {
					return
				}
				this.loading = true
				this.error = null

				loadTianditu()
					.then(() => this.initMap())
					.catch((err) => {
						console.error('地图脚本加载失败', err)
						this.loading = false
						this.error = err.message || '地图脚本加载失败，请检查网络连接后重试'
					})
			},

			// 弹窗是异步展开的，等容器真正有尺寸再建图，否则天地图会按 0×0 初始化
			waitForMapContainer(retries = 30) {
				return new Promise((resolve) => {
					const tick = (left) => {
						const el = this.$refs.mapContainer
						if (el && el.offsetWidth > 0 && el.offsetHeight > 0) {
							resolve(el)
						} else if (left <= 0) {
							resolve(null)
						} else {
							setTimeout(() => tick(left - 1), 100)
						}
					}
					tick(retries)
				})
			},

			async initMap() {
				const el = await this.waitForMapContainer()
				if (!el) {
					this.loading = false
					this.error = '地图容器未就绪，请重试'
					return
				}
				try {
					if (!this.map) {
						this.map = new window.T.Map(el)
						this.map.enableScrollWheelZoom()
					} else {
						// 复用同一个地图实例，重新打开时清掉上一次的图层再画
						if (this.map.checkResize) this.map.checkResize()
						this.map.clearOverLays()
					}
					this.markers = []
					this.labels = []
					this.routeLine = null
					this.fallbackLine = null

					// 先清错误再画，避免 renderRoute 里设置好的提示被覆盖掉
					this.error = null
					this.renderRoute()
					this.loading = false
				} catch (err) {
					console.error('地图初始化失败:', err)
					this.loading = false
					this.error = '地图初始化失败，请重试'
				}
			},

			/* ---------- 绘制 ---------- */
			renderRoute() {
				const start = this.parseLngLat(this.routeData && this.routeData.origin)
				const end = this.parseLngLat(this.routeData && this.routeData.destination)
				if (!start || !end) {
					this.error = '起终点坐标缺失，无法绘制路线'
					return
				}
				const T = window.T
				const car = this.getCarLngLat()

				// 起终点、车辆都自己画：REST 只返回点串不画标注，
				// 不自己加的话地图上就只有一条光秃秃的线
				this.addMarker(start, 'start')
				this.addMarker(end, 'end')
				if (car) this.addCarMarker(car)

				// 视野覆盖所有点
				const viewPoints = [start, end]
				if (car) viewPoints.push(car)
				this.fitView(viewPoints.map((p) => new T.LngLat(p.lng, p.lat)))

				// 运输中从车辆当前位置算路线，其余情况从路线起点算（与原逻辑一致）
				const from = (this.isTransporting() && car) ? car : start
				this.drawDrivingRoute(from, end)
			},

			// 后端给的坐标串是 "lng,lat"
			parseLngLat(value) {
				if (!value) return null
				const parts = String(value).split(',')
				if (parts.length < 2) return null
				const lng = Number(parts[0])
				const lat = Number(parts[1])
				if (isNaN(lng) || isNaN(lat)) return null
				return { lng, lat }
			},

			// 车辆当前位置：天地图是 WGS84，取原始 lat/lng；
			// 原来的 glat/blat 是已转成 GCJ-02 / BD-09 的坐标，打到天地图上反而会偏
			getCarLngLat() {
				const cp = this.carProgress
				if (!cp) return null
				const lat = Number(cp.lat)
				const lng = Number(cp.lng)
				if (isNaN(lat) || isNaN(lng)) return null
				return { lng, lat }
			},

			isTransporting() {
				return !!(this.orderData && this.orderData.statusName === '运输中')
			},

			// 用内联 SVG 做图标，不再依赖 mapapi.qq.com 上的腾讯 demo 图片
			buildSvgIcon(type) {
				const conf = {
					start: { w: 26, h: 34, color: '#67C23A', text: '起' },
					end: { w: 26, h: 34, color: '#F56C6C', text: '终' },
					car: { w: 32, h: 32, color: '#409EFF', text: '车' }
				}[type] || { w: 26, h: 34, color: '#409EFF', text: '' }

				const w = conf.w
				const h = conf.h
				const color = conf.color
				const text = conf.text

				// 起点/终点画成水滴形（圆头 + 尖尾），车辆画成圆形
				const shape = type === 'car' ?
					`<circle cx="${w / 2}" cy="${h / 2}" r="${w / 2 - 1}" fill="${color}" stroke="#ffffff" stroke-width="2"/>` :
					`<circle cx="${w / 2}" cy="${w / 2}" r="${w / 2 - 1}" fill="${color}" stroke="#ffffff" stroke-width="2"/>` +
					`<path d="M ${w / 2 - 6} ${w / 2 + 5} L ${w / 2} ${h - 1} L ${w / 2 + 6} ${w / 2 + 5} Z" fill="${color}"/>`

				const textY = type === 'car' ? h / 2 : w / 2
				const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">` +
					shape +
					`<text x="${w / 2}" y="${textY}" text-anchor="middle" dominant-baseline="central" ` +
					`font-size="${Math.round(w * 0.45)}" font-family="sans-serif" fill="#ffffff">${text}</text></svg>`

				return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
			},

			buildIcon(type) {
				const T = window.T
				const w = type === 'car' ? 32 : 26
				const h = type === 'car' ? 32 : 34
				return new T.Icon({
					iconUrl: this.buildSvgIcon(type),
					iconSize: new T.Point(w, h),
					// 起点/终点锚在尖尾，车辆锚在圆心
					iconAnchor: type === 'car' ? new T.Point(w / 2, h / 2) : new T.Point(w / 2, h)
				})
			},

			addMarker(pos, type) {
				const T = window.T
				const marker = new T.Marker(new T.LngLat(pos.lng, pos.lat), { icon: this.buildIcon(type) })
				this.map.addOverLay(marker)
				this.markers.push(marker)
				return marker
			},

			addCarMarker(pos) {
				const T = window.T
				const marker = new T.Marker(new T.LngLat(pos.lng, pos.lat), { icon: this.buildIcon('car') })
				marker.addEventListener('click', () => {
					this.carInfo = this.carProgress
					this.showCarInfo = true
				})
				this.map.addOverLay(marker)
				this.markers.push(marker)

				// 车牌号跟随显示：天地图的 Marker 不支持内嵌文字，用 Label 代替
				const carPlate = (this.carProgress && this.carProgress.carPlate) || ''
				if (carPlate) {
					try {
						const label = new T.Label({
							text: carPlate,
							position: new T.LngLat(pos.lng, pos.lat),
							offset: new T.Point(0, -22)
						})
						this.map.addOverLay(label)
						this.labels.push(label)
					} catch (e) {
						console.warn('车牌标注绘制失败', e)
					}
				}
				return marker
			},

			/* ---------- 路线规划 ---------- */
			// 按"最可能成功"的顺序取路线：先 REST（返回纯点串，链路最短），
			// 不行再试 JS API 的 DrivingRoute，最后才是虚线兜底。
			drawDrivingRoute(from, end) {
				this.routeSettled = false
				this.routeByRest(from, end)
			},

			async routeByRest(from, end) {
				const points = await this.requestDrivingRouteREST(from, end)
				if (this.routeSettled) return
				if (points && points.length > 1) {
					this.routeSettled = true
					this.drawPolyline(points)
					this.fitViewToRoute(from, end)
					return
				}
				console.warn('天地图 REST 驾车规划不可用，改试 JS API')
				this.routeByJsApi(from, end)
			},

			routeByJsApi(from, end) {
				const T = window.T
				if (!T || !T.DrivingRoute) {
					this.drawFallbackRoute(from, end)
					return
				}
				const fallbackTimer = setTimeout(() => {
					if (!this.routeSettled) {
						console.warn('天地图 JS API 驾车规划超时，改用直线示意')
						this.drawFallbackRoute(from, end)
					}
				}, 6000)

				let driving = null
				try {
					const opts = {
						// 自己控制视野，好把车辆当前位置一起框进去
						autoViewport: false,
						onSearchComplete: (result) => {
							clearTimeout(fallbackTimer)
							if (this.routeSettled) return
							if (this.isRouteResultOk(driving, result)) {
								this.routeSettled = true
								this.fitViewToRoute(from, end)
							} else {
								console.warn('天地图 JS API 驾车规划失败，改用直线示意', result)
								this.drawFallbackRoute(from, end)
							}
						}
					}
					if (T.DrivingPolicy && T.DrivingPolicy.LEAST_TIME) {
						opts.policy = T.DrivingPolicy.LEAST_TIME
					}
					driving = new T.DrivingRoute(this.map, opts)
					driving.search(new T.LngLat(from.lng, from.lat), new T.LngLat(end.lng, end.lat))
				} catch (e) {
					clearTimeout(fallbackTimer)
					console.error('JS API 路线规划失败', e)
					this.drawFallbackRoute(from, end)
				}
			},

			// 判断天地图是否真的返回了线路
			isRouteResultOk(driving, result) {
				try {
					if (driving && typeof driving.getStatus === 'function') {
						const status = driving.getStatus()
						if (status && status.errcode !== undefined && Number(status.errcode) !== 0) {
							return false
						}
					}
				} catch (e) {
					// getStatus 不可用就继续往下判断
				}
				if (!result) return false
				if (typeof result.getNumRoutes === 'function') {
					try {
						return result.getNumRoutes() > 0
					} catch (e) {
						return true
					}
				}
				return true
			},

			fitViewToRoute(from, end) {
				const T = window.T
				const points = [new T.LngLat(from.lng, from.lat), new T.LngLat(end.lng, end.lat)]
				const car = this.getCarLngLat()
				if (car) points.push(new T.LngLat(car.lng, car.lat))
				this.fitView(points)
			},

			// 天地图 REST 驾车规划：新版接口要求参数包在 postStr 里
			// （缺了会报 Required request parameter 'postStr'），老部署才认 orig/dest 查询参数
			requestDrivingRouteREST(from, end) {
				const orig = `${from.lng},${from.lat}`
				const dest = `${end.lng},${end.lat}`
				const postStr = JSON.stringify({ orig, dest, style: '0' })
				const urls = [
					`https://api.tianditu.gov.cn/drive?postStr=${encodeURIComponent(postStr)}&tk=${TIANDITU_TK}`,
					`https://api.tianditu.gov.cn/drive?orig=${orig}&dest=${dest}&style=0&tk=${TIANDITU_TK}`
				]

				return urls.reduce((chain, url) => chain.then((points) => {
					if (points) return points
					return this.fetchDrivingRoute(url)
				}), Promise.resolve(null))
			},

			fetchDrivingRoute(url) {
				return fetch(url, { method: 'GET' })
					.then((res) => {
						if (!res.ok) {
							console.warn(`天地图驾车规划接口返回 HTTP ${res.status}`)
							return null
						}
						return res.text()
					})
					.then((text) => {
						if (!text) return null
						const body = String(text).trim()
						// 天地图 /drive 实际返回的是 XML，不是 JSON
						if (body.charAt(0) === '<') {
							const raw = this.parseDriveXml(body)
							if (!raw) return null
							return this.parseRoutelatlonString(raw)
						}
						let data = null
						try {
							data = JSON.parse(body)
						} catch (e) {
							// 出错时接口返回的是 HTML 错误页
							console.warn('天地图驾车规划返回内容无法识别：', body.slice(0, 160))
							return null
						}
						return this.parseRouteLatLon(data)
					})
					.catch((e) => {
						console.warn('天地图驾车规划请求异常', e)
						return null
					})
			},

			// 天地图 /drive 返回的是 XML：
			// <result orig='..' dest='..'><parameters>..</parameters><routelatlon>lng,lat;..</routelatlon></result>
			parseDriveXml(text) {
				let doc = null
				try {
					doc = new DOMParser().parseFromString(text, 'text/xml')
				} catch (e) {
					console.warn('天地图驾车规划 XML 解析失败', e)
					return null
				}
				if (!doc || doc.getElementsByTagName('parsererror').length) {
					console.warn('天地图驾车规划返回的 XML 格式异常')
					return null
				}

				const nodes = doc.getElementsByTagName('routelatlon')
				if (!nodes.length) {
					const status = doc.getElementsByTagName('status')[0]
					console.warn('天地图驾车规划未返回路线：', status ? status.textContent : text.slice(0, 160))
					return null
				}

				// 长距离路线可能被拆成多段，按文档顺序拼起来
				let raw = ''
				for (let i = 0; i < nodes.length; i++) {
					raw += nodes[i].textContent || ''
				}
				return raw
			},

			// JSON 形态的返回（兼容）
			parseRouteLatLon(data) {
				if (!data) return null
				const result = data.result || data

				let raw = result.routelatlon || result.routeLatLon || result.routelatlng
				if (!raw && Array.isArray(result.routes) && result.routes.length) {
					const r0 = result.routes[0]
					raw = r0 && (r0.routelatlon || r0.routeLatLon || r0.routelatlng)
				}
				if (!raw) {
					const hint = data.msg || result.msg || data.status || result.status
					if (hint) console.warn('天地图驾车规划未返回路线：', hint, data)
					return null
				}
				return this.parseRoutelatlonString(raw)
			},

			// "lng,lat;lng,lat;"（结尾常带多余分号）→ LngLat 数组，坐标越界的一律丢弃
			parseRoutelatlonString(raw) {
				if (!raw || !window.T) return null
				const T = window.T
				const points = []
				const push = (a, b) => {
					const lng = Number(a)
					const lat = Number(b)
					if (!isFinite(lng) || !isFinite(lat)) return
					if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return
					points.push(new T.LngLat(lng, lat))
				}

				if (typeof raw === 'string') {
					// "lng,lat;lng,lat" 或扁平 "lng,lat,lng,lat"
					const segs = raw.trim().split(/[;|]+/).filter((s) => s && s.trim())
					if (segs.length > 1) {
						segs.forEach((seg) => {
							const pair = seg.split(',')
							if (pair.length >= 2) push(pair[0], pair[1])
						})
					} else {
						const nums = raw.trim().split(',')
						for (let i = 0; i + 1 < nums.length; i += 2) {
							push(nums[i], nums[i + 1])
						}
					}
				} else if (Array.isArray(raw)) {
					raw.forEach((item) => {
						if (Array.isArray(item) && item.length >= 2) push(item[0], item[1])
					})
				}

				return points.length > 1 ? points : null
			},

			drawPolyline(points) {
				const T = window.T
				this.routeLine = new T.Polyline(points, {
					color: '#3777FF',
					weight: 6,
					opacity: 1,
					lineStyle: 'solid'
				})
				this.map.addOverLay(this.routeLine)
				this.bringMarkersToFront()
			},

			// 线是在标注之后画的，会盖在图标上面，重挂一次把标注压回最上层
			bringMarkersToFront() {
				if (!this.map || !this.map.removeOverLay || !this.map.addOverLay) return
				const overlays = (this.markers || []).concat(this.labels || [])
				overlays.forEach((overlay) => {
					if (!overlay) return
					this.map.removeOverLay(overlay)
					this.map.addOverLay(overlay)
				})
			},

			// 路线服务不可用时的兜底：虚线直连（起终点在 renderRoute 里已经画过了）
			drawFallbackRoute(from, end) {
				if (this.routeSettled) return
				this.routeSettled = true
				this.drawStraightLine(from, end)
			},

			drawStraightLine(from, end) {
				const T = window.T
				if (!T || !this.map) return
				this.fallbackLine = new T.Polyline(
					[new T.LngLat(from.lng, from.lat), new T.LngLat(end.lng, end.lat)], {
						color: '#909399',
						weight: 4,
						opacity: 0.9,
						lineStyle: 'dashed'
					}
				)
				this.map.addOverLay(this.fallbackLine)
				this.bringMarkersToFront()
			},

			fitView(points) {
				if (!this.map || !Array.isArray(points) || !points.length) return
				try {
					this.map.setViewport(points)
				} catch (e) {
					this.map.centerAndZoom(points[0], 8)
				}
			}
		},

		beforeDestroy() {
			// 天地图没有 destroy()，把图层清掉、引用置空即可，DOM 会随组件一起销毁
			if (this.map && this.map.clearOverLays) {
				this.map.clearOverLays()
			}
			this.map = null
			this.markers = []
			this.labels = []
			this.routeLine = null
			this.fallbackLine = null
		}
	}
</script>